import { Component, OnInit } from '@angular/core';
import { MainServiceService } from './services/main-service.service';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { NullTemplateVisitor } from '@angular/compiler';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  title = 'consultaCUEApp';
  public loading: boolean = true;
  public jurisdicciones: string[] = [];
  public partidos: any[] = [];
  public localidades: any[] = [];
  public schools: any[] = [];
  public selectedProvincia: string = '';
  public selectedPartido: string = '';
  public selectedLocalidad: string = '';
  public selectedSchool: string;

  constructor(
    public _MainServiceService: MainServiceService,
    LoadingSpinnerComponent: LoadingSpinnerComponent
  ) {

  }

  ngOnInit(): void {
    this.getProvincias();
  }

  clearAll() {
    this.partidos = []
    this.localidades = []
    this.schools = []
    this.selectedPartido = null;
    this.selectedLocalidad = null;
    this.selectedSchool = null;

  }

  cleanFromPartidos() {
    this.localidades = []
    this.schools = []
    this.selectedLocalidad = null;
    this.selectedSchool = null;
  }

  cleanFromLocalidades() {
    this.schools = []
    this.selectedSchool = null;
  }

  getProvincias() {
    this.loading = true;
    this._MainServiceService.getProvincias().subscribe((res: any) => {
      this.jurisdicciones = res.jurisdicciones
      this.loading = false;
    },
      (error) => {
        alert('Error!' + error.error_code)
        this.loading = false;
      });
  }


  getPartidos() {
    console.log('Getting partidos')
    this.loading = true;
    this._MainServiceService.getPartidos(this.selectedProvincia).subscribe((res: any) => {
      console.dir(res.departamentos);
      this.partidos = res.departamentos;
      this.loading = false;
    },
      (error) => {
        alert('Error!' + error.error_code)
        this.loading = false;
      });
  }

  getLocalidades() {
    console.log('Getting localidades')
    this.loading = true;
    this._MainServiceService.getLocalidades(this.selectedProvincia, this.selectedPartido).subscribe((res: any) => {
      this.localidades = res.localidades
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        alert('Error!' + error.status)
      });

  }


  getEscuelas() {
    console.log('Getting Escuelas to ' + this.selectedProvincia, this.selectedPartido, this.selectedLocalidad)
    this.loading = true;
    this._MainServiceService.getEscuelas(this.selectedProvincia, this.selectedPartido, this.selectedLocalidad).subscribe((res: any) => {
      this.schools = res.establecimientos;
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        alert('Error!' + error.status)
      });

  }


  smoothscroll() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  setSelected(indice) {
    this.selectedSchool = this.schools[indice];
    this.smoothscroll();
  }


}
